export const getIconMarkup = (attribute) => {
    if (!attribute) {
        return '';
    }
    switch (attribute) {
        case 'rating.overallRating':
        case 'averageRating':
            return `
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                        <path d="M7.00055 2.8525L8.20805 5.29375L8.4093 5.73125L8.8468 5.79688L11.5418 6.18625L9.62555 8.0675L9.29742 8.38688L9.37617 8.82438L9.83555 11.5062L7.42492 10.2419L7.00055 10.0625L6.59367 10.2769L4.18305 11.5238L4.62055 8.84187L4.6993 8.40437L4.37555 8.0675L2.4418 6.16438L5.1368 5.775L5.5743 5.70937L5.77555 5.27187L7.00055 2.8525ZM7.00055 0.875L5.00992 4.90875L0.560547 5.55187L3.78055 8.69313L3.0193 13.125L7.00055 11.0337L10.9818 13.125L10.2205 8.69313L13.4405 5.55625L8.99117 4.90875L7.00055 0.875Z" />
                    </svg>
                `;
        case 'postDate':
            return `
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                        <path d="M11.375 1.75H9.625V0.875H8.75V1.75H5.25V0.875H4.375V1.75H2.625C2.14375 1.75 1.75 2.14375 1.75 2.625V11.375C1.75 11.8562 2.14375 12.25 2.625 12.25H11.375C11.8562 12.25 12.25 11.8562 12.25 11.375V2.625C12.25 2.14375 11.8562 1.75 11.375 1.75ZM11.375 11.375H2.625V5.25H11.375V11.375ZM11.375 4.375H2.625V2.625H4.375V3.5H5.25V2.625H8.75V3.5H9.625V2.625H11.375V4.375Z" />
                    </svg>
                `;
        case 'products.title':
        case 'product':
            return `
                <svg class="icon icon--menu"><use xlink:href="#products"></use></svg>
            `;
        case 'journeyTypes.title':
        case 'journeyType':
            return `
                <svg class="icon icon--milestone"><use xlink:href="#milestone"></use></svg>
            `;
        case 'brand.businessType.title':
        case 'businessType.title':
            return `
                <svg class="icon icon--finance"><use xlink:href="#finance"></use></svg>
            `;
        case 'geographies.title':
        case 'geography':
            return `
                <svg class="icon icon--menu"><use xlink:href="#globe"></use></svg>
            `;
        case 'tags.title':
        case 'combinedTags.title':
        case 'fcTags.title':
        case 'fcTags':
        case 'fcTag':
            return `
                <svg class="icon icon--tag"><use xlink:href="#tag"></use></svg>
            `;
        case 'brand.title':
            return `
                <svg class="icon icon--enterprise"><use xlink:href="#enterprise"></use></svg>
            `;
        case 'uiTags.title':
        case 'uiTags':
        case 'uiTag':
            return `
                <svg class="icon icon--gui"><use xlink:href="#gui"></use></svg>
            `;
        case 'tag':
            return `
                <svg class="icon icon--tag"><use xlink:href="#tag"></use></svg>
            `;
        case 'search':
            return `
                <svg class="icon icon--menu"><use xlink:href="#search"></use></svg>
            `;
        case 'ocr':
            return `
                <svg class="icon icon--menu"><use xlink:href="#evenOdd"></use></svg>
            `;
        default:
            return '';
    }

    // TODO refactor to use the <use> element
};

export const getRefinementDevicesIconMarkup = (label) => {
    if (!label) {
        return '';
    }

    switch (label) {
        case 'Mobile':
            return `
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 26">
                        <path d="M14 0H2C1.46973 0.000529477 0.961329 0.211413 0.586371 0.586371C0.211413 0.961329 0.000529477 1.46973 0 2V24C0.000608734 24.5302 0.211518 25.0386 0.586459 25.4135C0.9614 25.7885 1.46975 25.9994 2 26H14C14.5302 25.9993 15.0385 25.7883 15.4134 25.4134C15.7883 25.0385 15.9993 24.5302 16 24V2C15.9994 1.46975 15.7885 0.9614 15.4135 0.586459C15.0386 0.211518 14.5302 0.000608734 14 0ZM14 2V4H2V2H14ZM2 24V6H14V24H2Z" />
                    </svg>
                `;
        case 'Desktop':
            return `
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 32 32">
                        <path d="M30 26.0054V28.0054H2V26.0054H30ZM26 6.00537C26.5301 6.00598 27.0382 6.21652 27.4131 6.59131C27.788 6.96625 27.9994 7.47512 28 8.00537V22.0054C27.9992 22.5354 27.7879 23.0437 27.4131 23.4185C27.0382 23.7932 26.5301 24.0047 26 24.0054H6C5.46987 24.0048 4.96183 23.7932 4.58691 23.4185C4.21209 23.0436 4.00074 22.5354 4 22.0054V8.00537C4.00053 7.47522 4.21113 6.96624 4.58594 6.59131C4.9609 6.21635 5.46973 6.0059 6 6.00537H26ZM6 22.0054H26V8.00537H6V22.0054Z" />
                    </svg>
                `;
        default:
            return '';
    }
};
